<template>
  <div class="resumeContainer">
    <el-row
      v-if="positionInfoId"
      style="
        margin-top: 20px;
        margin-left: 20px;
        min-height: 40px;
        margin-bottom: 10px;
        background-color: #fafafa;
      "
    >
      <el-col :lg="{ span: 4, offset: 3 }" :xs="12">
        职位名称: {{ curPositionInfo.name }}
      </el-col>
      <el-col :lg="3" :xs="12">
        发布时间: {{ dateFormat(curPositionInfo.publishDate) }}
      </el-col>
      <el-col :lg="4" :xs="12">
        学历要求:
        {{
          curPositionInfo.eduRequireAndOver
            ? eduRequireFormat(curPositionInfo.eduRequire) + "及以上"
            : eduRequireFormat(curPositionInfo.eduRequire)
        }}
      </el-col>
      <el-col :lg="5" :xs="12">
        学科类别: {{ scienceValFormat(curPositionInfo.science) }}
      </el-col>
      <el-col :lg="5" :xs="12">
        专业要求: {{ curPositionInfo.careerRequire }}
      </el-col>
    </el-row>
    <div v-if="!isMb">
      <el-row style="margin-bottom: 10px">
        <el-col
          :lg="{ span: 8 }"
          :md="16"
          :sm="24"
          :xs="24"
          style="margin-top: 10px"
        >
          <el-row
            v-if="showButtons"
            type="flex"
            justify="space-around"
            :gutter="24"
            style="margin-bottom: 5px"
          >
            <el-col :span="5">
              <el-popover placement="bottom" trigger="click">
                <div>
                  <el-button
                    icon="el-icon-download"
                    type="primary"
                    @click="pdfPackage"
                    >pdf</el-button
                  >
                  <el-button
                    icon="el-icon-download"
                    type="primary"
                    @click="wordPackage"
                    >word</el-button
                  >
                </div>
                <el-button slot="reference" type="primary" style="float: right"
                  ><zr-icon icon="download"></zr-icon> 打包下载</el-button
                >
              </el-popover>
              <!--            <el-button type="primary" @click="patchDownload"-->
              <!--              ><zr-icon icon="download"></zr-icon> 打包下载</el-button-->
              <!--            >-->
            </el-col>
            <el-col :span="5">
              <el-button type="warning" @click="markReaded"
                ><zr-icon icon="bookmark"></zr-icon>
                {{ isMb ? "已读" : " 标记为已读" }}</el-button
              >
            </el-col>
            <el-col
              v-if="activeName == 'postSend' || activeName == 'collected'"
              :span="6"
            >
              <el-button v-if="!isOpend" type="danger" @click="markNotFit"
                ><zr-icon icon="bell-slash"></zr-icon
                >{{ isMb ? "不合适" : " 标记为不合适" }}
              </el-button>
              <el-popover
                v-if="isOpend"
                v-model="popVisible"
                placement="bottom"
                width="400"
                trigger="click"
              >
                <div>
                  <el-row>
                    <el-input
                      v-model="noFitMessage"
                      placeholder="可添加额外信息到邮件正文，不填则为默认统一格式"
                      maxlength="50"
                      clearable
                    ></el-input>
                  </el-row>
                  <el-row style="margin-top: 10px">
                    <el-button
                      icon="el-icon-circle-check"
                      type="success"
                      style="float: right"
                      @click="markNotFit"
                      >确定</el-button
                    >
                    <el-button
                      icon="el-icon-circle-close"
                      style="float: right"
                      @click="popVisible = false"
                      >取消</el-button
                    >
                  </el-row>
                </div>
                <el-button slot="reference" type="danger"
                  ><zr-icon icon="bell-slash"></zr-icon
                  >{{ isMb ? "不合适" : " 标记为不合适" }}</el-button
                >
              </el-popover>
            </el-col>
            <el-col :span="4">
              <el-button
                v-if="activeName == 'postSend'"
                type="success"
                @click="markFavorite"
                ><zr-icon v-if="showTable" icon="bell"></zr-icon>
                收藏</el-button
              >
              <el-button
                v-if="activeName == 'collected'"
                type="info"
                @click="unmarkFavorite"
                ><zr-icon v-if="showTable" icon="bell-slash"></zr-icon>
                取消收藏</el-button
              >
            </el-col>
          </el-row>
        </el-col>
        <el-col
          :lg="{ span: 10, offset: 6 }"
          :md="8"
          :sm="24"
          :xs="24"
          style="margin-top: 10px"
        >
          <el-row
            type="flex"
            justify="space-around"
            :gutter="10"
            style="margin-left: 5px; margin-bottom: 5px"
          >
            <el-col :span="7">
              投递时间(起)
              <el-date-picker
                v-model.trim="queryForm.sendDateStart"
                style="width: 150px"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="投递时间(起)"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="7">
              投递时间(止)
              <el-date-picker
                v-model.trim="queryForm.sendDateEnd"
                style="width: 150px"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="投递时间(止)"
              >
              </el-date-picker
            ></el-col>
            <el-col :span="7">
              是否导出不合格简历
              <el-select
                v-model="isSuitable"
                placeholder="是否导出不合格简历"
              >
                <el-option
                  v-for="item in [
                    { name: '是', code: '是' },
                    { name: '否', code: '否' },
                  ]"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-around"
            :gutter="10"
            style="margin-left: 5px; margin-bottom: 5px"
          >
            <el-col :span="7">
              姓名
              <el-input
                v-model.trim="queryForm.name"
                style="width: 100px"
                placeholder="姓名"
                clearable
              >
              </el-input>
            </el-col>
            <el-col :span="7"
              >职位
              <el-input
                v-model.trim="queryForm.postName"
                style="width: 100px"
                placeholder="职位"
                clearable
              >
              </el-input>
            </el-col>
            <el-col :span="7">
              毕业学校
              <el-input
                v-model.trim="queryForm.university"
                style="width: 100px"
                placeholder="毕业学校"
                clearable
              >
              </el-input
            ></el-col>
            <el-col :span="3">
              <el-button
                icon="el-icon-search"
                type="default"
                @click="resetData"
              >
                <span class="hidden-sm-and-down">重置</span>
              </el-button>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-around"
            :gutter="10"
            style="margin-left: 5px; margin-bottom: 5px"
          >
            <el-col :span="7">
              专业
              <el-input
                v-model.trim="queryForm.studyField"
                style="width: 100px"
                placeholder="专业"
                clearable
              >
              </el-input>
            </el-col>
            <el-col :span="7">
              学历
              <el-input
                v-model.trim="queryForm.phase"
                style="width: 100px"
                placeholder="学历"
                clearable
              >
              </el-input
            ></el-col>
            <el-col :span="7">
              政治面貌
              <el-input
                v-model.trim="queryForm.politicallyState"
                style="width: 100px"
                placeholder="政治面貌"
                clearable
              >
              </el-input>
            </el-col>
            <el-col :span="3">
              <el-button
                icon="el-icon-search"
                type="primary"
                @click="queryData"
              >
                <span class="hidden-sm-and-down">查询</span>
              </el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="tagsBox">
        <el-col :lg="10" :xs="14">
          <el-badge
            :value="statisticData.resumeInfoCount"
            class="item"
            type="info"
          >
            <el-tag
              :class="activeName == 'postSend' ? 'tagActive' : ''"
              type="info"
              @click="handleClick('postSend')"
              >投递</el-tag
            >
          </el-badge>
          <el-badge
            :value="statisticData.collectCount"
            class="item"
            type="info"
          >
            <el-tag
              :class="activeName == 'collected' ? 'tagActive' : ''"
              type="success"
              @click="handleClick('collected')"
              >收藏</el-tag
            >
          </el-badge>
          <el-badge :value="statisticData.unSuitCount" class="item" type="info">
            <el-tag
              :class="activeName == 'unFit' ? 'tagActive' : ''"
              type="warning"
              @click="handleClick('unFit')"
              >不合适</el-tag
            >
          </el-badge>
        </el-col>
        <el-col :lg="8" :xs="24">
          <div v-if="activeName == 'collected'" style="margin-left: 10px">
            <el-date-picker
              v-model="cltStartDate"
              placeholder="开始时间"
              style="width: 135px"
            ></el-date-picker>
            至
            <el-date-picker
              v-model="cltEndDate"
              placeholder="截止时间"
              style="width: 135px"
            ></el-date-picker>
          </div>
        </el-col>
        <el-col v-if="is12" :lg="14" :xs="10" style="float: right">
          <el-button
            type="primary"
            style="float: right"
            icon="el-icon-edit"
            @click="emailConfig"
            >邮箱配置</el-button
          >
          <el-button
            style="float: right; margin-right: 5px"
            icon="el-icon-setting"
            @click="configPage"
          >
            权重配置</el-button
          >
          <el-button v-if="isShowButton" type="primary" style="float: right" @click="excelImport"
            ><zr-icon icon="el-icon-upload "></zr-icon
            >投递结果excel导入</el-button
          >
          <el-button v-if="isShowButton" type="primary" style="float: right" @click="setSendResult"
          ><zr-icon icon="el-icon-upload "></zr-icon
          >手动设置投递结果</el-button
          >
          <el-button v-if="isShowButton" type="info" style="float: right" @click="excelRecordLoad"
            ><zr-icon icon="el-icon-view"></zr-icon> 导出日志查询</el-button
          >
          <el-button
            v-if="isShowButton"
            type="info"
            style="float: right"
            @click="wordPackageAfterExcel"
            ><zr-icon icon="download"></zr-icon> 打包下载</el-button
          >
          <el-button v-if="isShowButton" type="info" style="float: right" @click="excelExport"
            ><zr-icon icon="download"></zr-icon> excel导出</el-button
          >
          <!--          <el-button type="info" style="float: right" @click="resumeExcelExport"-->
          <!--          ><zr-icon icon="download"></zr-icon>简历数据导出</el-button-->
          <!--          >-->
          <!--          <el-button type="primary" style="float: right" @click="endRecruitQuarter" v-if="isAdmin"-->
          <!--          ><zr-icon icon="lock"></zr-icon>结束招聘季</el-button-->
          <!--          >-->
        </el-col>
      </el-row>
      <zr-page-table
        ref="pageTable"
        class="page-box"
        :loading-show="listLoading"
        :data="list"
        :row-class-name="tableRowClassName"
        :page-sizes="pageSizes"
        :columns="realCols"
        :total="total"
        :page-index="pageIndex"
        enabled-selection
        @refresh-page="fetchPageData"
      >
        <template v-slot:age="{ row }">
          <span v-if="row.autoIsSuitable === 'age'" style="color: red">{{
            row.age
          }}</span>
          <span v-else>
            {{
              row.age
            }}
          </span>
        </template>
        <template v-slot:phase="{ row }">
          <span v-if="row.autoIsSuitable === 'phase'" style="color: red">{{
              row.phase
            }}</span>
          <span v-else>
            {{
              row.phase
            }}
          </span>
        </template>
        <template v-slot:university="{ row }">
          <span v-if="row.autoIsSuitable === 'university'" style="color: red">{{
              row.university
            }}</span>
          <span v-else>
            {{
              row.university
            }}
          </span>
        </template>
        <template v-slot:postName="{ row }">
          <span v-if="row.autoIsSuitable === 'close'" style="color: red">{{
              row.postName
            }}</span>
          <span v-else>
            {{
              row.postName
            }}
          </span>
        </template>
        <template v-slot:name="{ row }">
          <el-link
            type="primary"
            @click="viewResume(row.id, row.phase, row.university)"
            >{{ row.name }}</el-link
          >
        </template>
        <template v-slot:isRead="{ row }">
          <el-tag v-if="row.isRead == 0" type="success"
            ><zr-icon icon="check"></zr-icon
          ></el-tag>
        </template>
        <template v-slot:status="{}">
          <span v-if="activeName == 'postSend'" class="waiting"
            ><zr-icon v-if="showTable" icon="clock"></zr-icon> 待审核</span
          >
          <span v-if="activeName == 'unFit'" class="notPass"
            ><zr-icon v-if="showTable" icon="hands-helping"></zr-icon>
            不合适</span
          >
          <span v-if="activeName == 'collected'" class="primarySelect"
            ><zr-icon v-if="showTable" icon="star-half-alt"></zr-icon>
            审核中</span
          >
        </template>
        <template v-slot:operate="{ row }">
          <el-button type="text" @click="handleDownPdf(row)">pdf </el-button>
          <el-button type="text" @click="handleDownWord(row)">word </el-button>
        </template>
      </zr-page-table>
      <!--    <ResumeList
        v-if="!listLoading"
        :data="list"
        :basic-datas="basicDatas"
      ></ResumeList>-->
    </div>
    <!--    手机版--------------------------------------------------------->
    <div v-else>
      <el-row type="flex" justify="space-around">
        <el-col :span="6">
          <el-input
            v-model.trim="queryForm.name"
            style="width: 90px"
            placeholder="姓名"
            clearable
          >
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input
            v-model.trim="queryForm.phase"
            style="width: 90px"
            placeholder="学历"
            clearable
          >
          </el-input
        ></el-col>
        <el-col :span="6">
          <el-input
            v-model.trim="queryForm.postName"
            style="width: 90px"
            placeholder="职位"
            clearable
          >
          </el-input>
        </el-col>
        <el-col :span="3">
          <el-button icon="el-icon-search" type="primary" @click="queryData">
            <span class="hidden-sm-and-down"></span>
          </el-button>
        </el-col>
      </el-row>
      <el-row style="margin-left: 5px">
        <el-badge
          :value="statisticData.resumeInfoCount"
          class="item"
          type="info"
        >
          <el-tag
            :class="activeName == 'postSend' ? 'tagActive' : ''"
            type="info"
            @click="handleClick('postSend')"
            >投递</el-tag
          >
        </el-badge>
        <el-badge :value="statisticData.collectCount" class="item" type="info">
          <el-tag
            :class="activeName == 'collected' ? 'tagActive' : ''"
            type="success"
            @click="handleClick('collected')"
            >收藏</el-tag
          >
        </el-badge>
        <el-badge :value="statisticData.unSuitCount" class="item" type="info">
          <el-tag
            :class="activeName == 'unFit' ? 'tagActive' : ''"
            type="warning"
            @click="handleClick('unFit')"
            >不合适</el-tag
          >
        </el-badge>
        <div v-if="activeName == 'collected'">
          <el-date-picker
            v-model="cltStartDate"
            style="width: 145px"
            placeholder="开始时间"
          ></el-date-picker>
          至
          <el-date-picker
            v-model="cltEndDate"
            style="width: 145px"
            placeholder="结束时间"
          ></el-date-picker>
        </div>
      </el-row>
      <el-row v-for="post in list" :key="post.id" class="postInfo" :gutter="10">
        <el-col
          style="margin-left: 10px"
          :class="post.isRead == 0 ? 'postInfo1' : 'postInfo2'"
        >
          <el-row class="p-first"
            ><el-link
              :underline="false"
              type="primary"
              class="content-break"
              @click="viewResume(post.id, post.phase, post.university)"
              ><span class="index"> {{ post.index + "." }}</span>
              <span class="name"> {{ post.name }}</span>
              <span class="phase"> {{ eduRequireFormat(post.phase) }}</span>
              <span class="sex"> {{ sexFormat(post.sex) }}</span
              ><span class="age"> {{ post.age + "岁" }}</span
              ><span class="isRead">
                <el-tag v-if="post.isRead == 0" type="success"
                  ><zr-icon icon="check"></zr-icon></el-tag></span></el-link
          ></el-row>
          <el-row class="p-second"
            ><span class="postName"> {{ post.postName }}</span
            ><span class="university"> {{ post.university }}</span
            ><span class="studyField"> {{ post.studyField }}</span></el-row
          >
          <el-row class="p-third">
            <span> {{ dateFormat(post.sendDate) }}</span>
            <span style="float: right; margin-right: 10px"
              ><el-button type="text" @click="handleDownPdf(post)">
                pdf下载
              </el-button>
              <el-button type="text" @click="handleDownWord(post)">
                word下载
              </el-button></span
            >
          </el-row>
        </el-col>
      </el-row>
      <el-pagination
        ref="elPage"
        background
        :page-sizes="pageSizes"
        :page-size="pageSize"
        :current-page="pageIndex"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="float: right; padding-right: 5px; margin-bottom: 15px"
        @current-change="currentPageChange"
        @size-change="pageSizeChange"
      ></el-pagination>
      <!--    <ResumeList
        v-if="!listLoading"
        :data="list"
        :basic-datas="basicDatas"
      ></ResumeList>-->
    </div>
    <!--   权重配置弹窗页面--------------------------------------------------------->
    <CommDialog
      ref="configDialogRef"
      dialog-title="权重配置（各项分数）"
      :add-init-data="addInitData"
      :show-footer="true"
      :dialog-data="dialogData"
      :dialog-visible.sync="dialogVisible"
      :init-data="initDialogData"
      :save-data="saveDialogData"
      :rules="dialogRules"
      width="80%"
      @dialogVisibleChange="dialogVisibleChange"
      @callBack="dialogCallBack"
    >
      <template v-slot:content="{ form }">
        <el-card>
          <div slot="header" class="clearfix">
            <span style="font-weight: bolder">英语能力</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="cet4" prop="cet4">
                <el-input-number
                  v-model="form.cet4"
                  placeholder="cet4分值"
                  size="mini"
                  :min="0"
                  :max="100"
                  :precision="0"
                  :step="1"
                  clearable
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="cet6" prop="cet6">
                <el-input-number
                  v-model="form.cet6"
                  placeholder="cet6分值"
                  size="mini"
                  :min="0"
                  :max="100"
                  :precision="0"
                  :step="1"
                  clearable
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="tem4" prop="tem4">
                <el-input-number
                  v-model="form.tem4"
                  placeholder="tem4分值"
                  size="mini"
                  :min="0"
                  :max="100"
                  :precision="0"
                  :step="1"
                  clearable
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="tem8" prop="tem8">
                <el-input-number
                  v-model="form.tem8"
                  placeholder="tem8分值"
                  size="mini"
                  :min="0"
                  :max="100"
                  :precision="0"
                  :step="1"
                  clearable
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card>
          <div slot="header" class="clearfix">
            <span style="font-weight: bolder">学位</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="学士" prop="学士">
                <el-input-number
                  v-model="form.学士"
                  placeholder="学士分值"
                  size="mini"
                  :min="0"
                  :max="100"
                  :precision="0"
                  :step="1"
                  clearable
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="硕士" prop="硕士">
                <el-input-number
                  v-model="form.硕士"
                  placeholder="硕士分值"
                  size="mini"
                  :min="0"
                  :max="100"
                  :precision="0"
                  :step="1"
                  clearable
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="博士" prop="博士">
                <el-input-number
                  v-model="form.博士"
                  placeholder="博士分值"
                  size="mini"
                  :min="0"
                  :max="100"
                  :precision="0"
                  :step="1"
                  clearable
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card>
          <div slot="header" class="clearfix">
            <span style="font-weight: bolder">学校</span>
          </div>
          <el-col
            v-for="(university, index) in universityList"
            :key="university.name"
            :span="6"
          >
            <span style="float: left">{{
              index + 1 + "." + university.name
            }}</span>
            <el-input-number
              v-model="form[university.name]"
              style="float: right; margin-right: 20px"
              placeholder="分值"
              size="mini"
              :min="0"
              :max="100"
              :precision="0"
              :step="1"
              controls-position="right"
              clearable
            ></el-input-number>
          </el-col>
        </el-card>
      </template>
    </CommDialog>
    <!--   邮箱配置弹窗页面--------------------------------------------------------->
    <CommDialog
      dialog-title="邮箱配置（本所招聘邮箱）"
      :add-init-data="emailAddInitData"
      :show-footer="true"
      :dialog-data="emailDialogData"
      :dialog-visible.sync="emailDialogVisible"
      :init-data="emailInitDialogData"
      :save-data="emailSaveDialogData"
      :rules="emailDialogRules"
      width="50%"
      @dialogVisibleChange="emailDialogVisibleChange"
      @callBack="emailDialogCallBack"
    >
      <template v-slot:content="{ form }">
        <el-card>
          <div slot="header" class="clearfix">
            <span style="font-weight: bolder">功能描述</span>
          </div>
          <span style="margin-left: 20px"
            >功能说明：正确配置本页面并开启功能后，在对本所简历标记不合适的同时，系统会以此处配置邮箱的名义发送统一格式的邮件到学生邮箱，告知学生被拒。若不需要此功能请忽略本配置页。</span
          ><br />
        </el-card>
        <el-card>
          <div slot="header" class="clearfix">
            <span style="font-weight: bolder">邮箱及授权码配置</span>
          </div>
          <el-row>
            <el-col :span="16">
              <el-form-item label="邮箱" prop="email">
                <el-input
                  v-model="form.email"
                  placeholder="邮箱地址，如XXX@caep.com"
                  clearable
                  @blur="readEmail(form.email, form)"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否启用" prop="isOpen" style="float: right">
                <el-switch
                  v-model="form.isOpen"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                >
                </el-switch>
                <span style="margin-left: 5px; color: gray">(绿色为开启)</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="授权码" prop="key">
            <el-input
              v-model="form.key"
              placeholder="POP3/SMPT授权码。需要到邮箱设置中开启此功能。"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="发信服务器地址" prop="address">
            <el-input
              v-model="form.address"
              placeholder="发信服务器地址。qq邮箱填写smtp.qq.com，163邮箱填写smtp.163.com"
              clearable
            ></el-input
          ></el-form-item>
        </el-card>
        <el-card>
          <div slot="header" class="clearfix">
            <span style="font-weight: bolder">授权码获取说明</span>
          </div>
          <span style="margin-left: 20px">1.以网易邮箱和qq邮箱举例：</span
          ><br />
          <span
            >网易邮箱：设置->POP3/SMTP/IMAP->开启POP3/SMTP服务->验证获取授权码</span
          ><br />
          <span
            >qq邮箱：设置->账户->POP3/IMAP/SMTP...服务->开启POP3/SMTP服务->验证获取授权码</span
          ><br />
          <span style="margin-left: 20px"
            >2.点击下面链接跳转至详细操作步骤：</span
          ><br />
          <span style="margin-left: 20px"
            ><a @click="openURL(1)">以网易邮箱为例</a></span
          >
          &nbsp;
          <span style="margin-left: 20px"
            ><a @click="openURL(2)">以QQ邮箱为例</a></span
          >
        </el-card>
        <el-card>
          <div slot="header" class="clearfix">
            <span style="font-weight: bolder">发信服务器地址说明</span>
          </div>
          <span style="margin-left: 20px"
            >例：1.使用qq邮箱，则填写smtp.qq.com<br
          /></span>
          <span style="margin-left: 50px"
            >2.使用163邮箱，则填写smtp.163.com<br
          /></span>
          <span style="margin-left: 50px"
            >3.使用126邮箱，则填写smtp.126.com</span
          >
        </el-card>
      </template>
    </CommDialog>
    <!--导出日志查询-->
    <ExcelRecord ref="excelRecord"> </ExcelRecord>
    <UploadFileModel ref="uploadFileModel"></UploadFileModel>
    <set-result-dialog ref="resultDialog" @confirm="handleAuditConfirm"></set-result-dialog>
  </div>
</template>

<script>
import commFormat from "zr-util/src/utils/comm/commFormat";
import { defaultPageSizes } from "@/config/settings";
import {
  getResumePage,
  getResumeTypeStatisticData,
  markIsRead,
  downloadPdf,
  downloadWord,
  downloadPdfPackage,
  downloadWordPackage,
  downloadExcel,
  downloadPreCheck,
  saveConfigData,
  getConfigData,
  getEmailData,
  saveEmailData,
  getsImportExcelRecord,
} from "@api/recruit/hr/resumeManagement";
import {endRecruitQuarter, setResultByHand} from "@/api/recruit/hr/positionManagement";
import {
  deleteData,
  deleteType,
  searchBasicData,
} from "@api/framework/basicData/dataDictType";
var nowYear = new Date().getFullYear();
import { mapGetters } from "vuex";
import ResumeList from "^/recruit/resumeList";
import {
  collectResume,
  unCollectResume,
  unSuitResume,
} from "@api/recruit/user/resume";
import { getBasicData, searchPostInfoById } from "@api/job/postInfo";
import { isArray } from "zr-util/src/utils/comm/validate";
import { messageDuration } from "../../../config/settings";
import { downloadFile } from "@/utils/downFile";
import store from "@/store";
import isMobile from "@/utils/device";
const isMb = isMobile();
import CommDialog from "^/zr/dialog/commDialog";
import ExcelRecord from "^/zr/dialog/excelRecord.vue";
import UploadExcelImport from "^/zr/dialog/uploadExcelImport.vue";
import UploadFileModel from "^/zr/dialog/uploadExcelImport.vue";
import fa from "element-ui/src/locale/lang/fa";
import setResultDialog from "^/zr/dialog/setResultDialog.vue";

let def_pageSize = defaultPageSizes[0];
let def_pageIndex = 1;
let query = undefined;

export default {
  name: "ResumeManagement",
  components: { UploadFileModel, CommDialog, ExcelRecord,setResultDialog },
  // components: { ResumeList },
  data() {
    return {
      isShowButton:true,
      isSuitable: "否",
      isMb: isMb,
      isOpend: false, // 邮件功能是否开启
      is12: true, // excel导出及权重配置功能是否开启
      dialogVisible: false, // 权重配置页面
      emailDialogVisible: false, // 邮箱配置页面
      curPositionInfo: {},
      showTable: true,
      popVisible: false,
      positionInfoId: "",
      noFitMessage: "", // 不合适时要发送邮件的信息
      eduTypeArray: [],
      scienceArray: [],
      query: {},
      activeName: "postSend",
      queryForm: {
        name: "",
        phase: "",
        postName: "",
      },
      statisticData: {
        collectCount: 0,
        resumeInfoCount: 0,
        unSuitCount: 0,
      },
      filterProps: {},
      list: [],
      listLoading: true,
      pageInfo: { pageIndex: def_pageIndex, pageSize: def_pageSize },
      total: 0,
      pageIndex: 1,
      pageSizes: defaultPageSizes,
      pageSize: defaultPageSizes[0],
      basicDatas: [],
      cltStartDate: undefined,
      cltEndDate: undefined,
      columns: [
        { code: "index", name: "序号", width: "50px" },
        { code: "name", name: "姓名", needDrawCell: true },
        {
          code: "sex",
          name: "性别",
          formatter: (row, value) => {
            if (value == "female") {
              return "女";
            } else {
              return "男";
            }
          },
          width: 50,
        },
        {
          code: "age",
          name: "年龄",
          width: 50,
          needDrawCell: true,
        },
        {
          code: "politicallyState",
          name: "政治面貌",
          formatter: (row, value) => {
            // if (value == "partyMember") {
            //   return "党员";
            // } else {
            //   return "群众";
            // }
            if (value === "partyMember") {
              return "中共党员";
            } else if (value === "中共预备党员") {
              return "中共预备党员";
            } else if (value === "共青团员") {
              return "共青团员";
            } else if (value === "民革会员") {
              return "民革会员";
            } else if (value === "民盟盟员") {
              return "民盟盟员";
            } else if (value === "民建会员") {
              return "民建会员";
            } else if (value === "民进会员") {
              return "民进会员";
            } else if (value === "农工党党员") {
              return "农工党党员";
            } else if (value === "致公党党员") {
              return "致公党党员";
            } else if (value === "九三学社社员") {
              return "九三学社社员";
            } else if (value === "台盟盟员") {
              return "台盟盟员";
            } else if (value === "无党派民主人士") {
              return "无党派民主人士";
            } else if (value === "其他") {
              return "其他";
            } else {
              return "群众";
            }
          },
          width: 150,
        },
        { code: "phase", name: "学历", width: 130, needDrawCell: true },
        { code: "studyField", name: "专业" },
        { code: "university", name: "毕业学校(学历从低到高)", width: 300,needDrawCell: true },
        {
          code: "postType",
          name: "职位类型",
          formatter: (row, value) => {
            for (let i = 0, len = this.basicDatas.length; i < len; i++) {
              if (value == this.basicDatas[i].code) {
                return this.basicDatas[i].name;
              }
            }
            return value;
          },
          width: 100,
        },
        { code: "postName", name: "应聘职位名称", needDrawCell: true },
        {
          code: "sendDate",
          name: "投递日期",
          formatter: (row, value) => {
            if (typeof value == "string") {
              return value.substring(0, 10);
            } else {
              return commFormat.formatDate(value, "yyyy-MM-dd");
            }
          },
          width: 100,
        },
        // {
        //   code: "status",
        //   name: "状态",
        //   needDrawCell: true,
        // },
        {
          code: "isRead",
          name: "已读",
          needDrawCell: true,
          width: 50,
        },
        {
          code: "operate",
          name: "简历下载",
          width: "80",
          fixed: "right",
          needDrawCell: true,
        },
      ],
      // 权重配置页,初始化参数
      dialogData: {},
      universityList: [],
      addInitData: {
        id: null,
        name: "123",
        deptCode: this.deptCode,
      },
      dialogRules: {
        // name: [
        //   { required: true, message: "请输入角色显示名称", trigger: "blur" },
        //   {
        //     min: 2,
        //     max: 15,
        //     message: "长度在 2 到 15 个字符",
        //     trigger: "blur",
        //   },
        // ],
      },
      // 邮箱配置页,初始化参数
      emailDialogData: {},
      emailAddInitData: {
        id: null,
        key: "123",
        email: "321",
        deptCode: this.deptCode,
      },
      emailDialogRules: {
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        key: [{ required: true, message: "请输入授权码", trigger: "blur" }],
        address: [
          { required: true, message: "请输入发信服务器地址", trigger: "blur" },
        ],
      },
      isAdmin: false,
    };
  },
  computed: {
    ...mapGetters({
      curRole: "user/curRole",
      userCode: "user/userCode",
      deptCode: "user/deptCode",
    }),
    showButtons() {
      return this.curRole == "hrAdmin" || this.curRole == "admin";
    },
    realCols() {
      return this.showButtons ? this.columns : this.columns.slice(0, 11);
    },
  },
  watch: {
    $route: {
      handler(route) {
        this.positionInfoId = (route.query && route.query.positionInfoId) || "";
      },
      immediate: true,
    },
  },
  async created() {
    let size = def_pageSize;
    let index = def_pageIndex;
    if (query) {
      if (query.activeName) {
        this.activeName = query.activeName;
      }
      if (query.queryForm) {
        this.queryForm = query.queryForm;
      }
      if (query.pageSize) {
        size = query.pageSize;
      }
      if (query.pageIndex) {
        index = query.pageIndex;
      }
    }
    if (this.positionInfoId) {
      await this.initPositionInfo();
    }
    await this.initScienceType();
    await this.getEduTypeArray();
    await this.initBasicDatas();
    await this.initStatisticData();
    await this.initNoFitMessage();
    await this.fetchPageData({
      pageSize: parseInt(size),
      pageIndex: parseInt(index),
    });
  },
  beforeRouteEnter(to, from, next) {
    const preName = from.name;
    query = undefined;
    if (preName == "PersonalResumeView") {
      query = from.query;
    }
    next();
  },
  mounted() {
    this.inintEmail();
    let curRole = store.getters["user/curRole"];
    if (curRole === "admin") {
      this.isAdmin = true;
    }
    // 如果从投递点来隐藏按钮
    if (this.$route.query.isPositionGo) {
      this.isShowButton =false
    }
  },
  methods: {
    // 表格行渲染
    tableRowClassName({ row, rowIndex }) {
      if (row.isRead == 0 || row.isRead == "0") {
        return "gray-row";
      }
    },
    inintEmail() {
      if (this.deptCode) {
        // 查询是否开启邮件功能
        getEmailData({ deptCode: this.deptCode }).then((res) => {
          if (res.success) {
            if (
              res.data &&
              res.data.email &&
              res.data.key &&
              res.data.address &&
              res.data.isOpen == "true"
            ) {
              this.isOpend = true;
            } else {
              this.isOpend = false;
            }
          } else {
            this.$message({
              showClose: true,
              message: "查询邮件功能是否开启：接口访问失败!" + res.message,
              type: "error",
            });
          }
        });
        // 12所特约功能
        // if (this.deptCode == "9012swcc" || this.userCode == "admin") {
        //   this.is12 = true;
        // }
      }
    },
    async currentPageChange(val) {
      this.pageIndex = val;
      this.pageInfo.pageIndex = this.pageIndex;
      await this.fetchPageData(this.pageInfo);
    },
    async pageSizeChange(val) {
      this.pageIndex = 1;
      this.pageSize = val;
      this.pageInfo.pageSize = this.pageSize;
      await this.fetchPageData(this.pageInfo);
    },
    async initScienceType() {
      const res = await searchBasicData({ typeCode: "scienceType" });
      if (res.success) {
        this.scienceArray = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    async getEduTypeArray() {
      let res = await getBasicData({ typeCode: "eduRequire" });
      if (res.success) {
        this.eduTypeArray = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    async initPositionInfo() {
      const res = await searchPostInfoById({
        positionInfoId: this.positionInfoId,
      });
      if (res.success) {
        this.curPositionInfo = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    async initStatisticData() {
      const res = await getResumeTypeStatisticData({
        deptCode: this.deptCode,
        postInfoId: this.positionInfoId,
      });
      if (res.success) {
        //do
        this.statisticData = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    async initBasicDatas() {
      const res = await searchBasicData({ typeCode: "postType" });
      if (res.success) {
        this.basicDatas = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    async initNoFitMessage() {
      // const res = await searchBasicData({ typeCode: "noFitMessage" });
      // if (res.success) {
      //   this.noFitMessage = res.data[0].remark;
      // } else {
      //   this.$message.error({ showClose: true, message: res.message });
      // }
    },
    async handleClick(name) {
      this.cltStartDate = undefined;
      this.cltEndDate = undefined;
      this.activeName = name;
      await this.fetchPageData({
        pageSize: defaultPageSizes[0],
        pageIndex: 1,
      });
    },
    // 批量标记后刷新当前页
    async refreshPage() {
      await this.fetchPageData({
        pageSize: defaultPageSizes[0],
        pageIndex: 1,
      });
      await this.initStatisticData();
    },
    resetData() {
      this.queryForm = [];
    },
    async queryData() {
      await this.fetchPageData({
        pageSize: defaultPageSizes[0],
        pageIndex: 1,
      });
    },
    async fetchPageData(pageInfo) {
      this.showTable = false;
      this.pageIndex = pageInfo.pageIndex;
      pageInfo.deptCode = this.deptCode;
      pageInfo.action = this.activeName;
      if (this.activeName == "collected") {
        pageInfo.collectStartDate = this.cltStartDate;
        pageInfo.collectEndDate = this.cltEndDate;
      }
      this.listLoading = true;
      pageInfo.filterProps = this.filterProps;
      this.pageInfo = pageInfo;
      const res = await getResumePage({
        ...pageInfo,
        ...this.queryForm,
        postInfoId: this.positionInfoId,
      });
      if (res.success) {
        let data = res.data;
        this.listLoading = false;
        this.list = data.data;
        this.list = this.list.map((value) => {
          var age;
          if (value.birthday && value.birthday.length > 4) {
            var birthday = value.birthday.substring(0, 4);
            //计算年龄
            age = nowYear - parseInt(birthday);
          }
          value.age = age;
          return value;
        });
        this.total = data.total;
        this.$nextTick(() => {
          if (this.$refs.pageTable) {
            this.$refs.pageTable.clearSelection();
          }
        });
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
      setTimeout(() => {
        this.listLoading = false;
      }, 300);
      this.$nextTick(() => {
        this.showTable = true;
      });
    },
    async handleDownPdf(row) {
      // await downloadPdf({ id: row.postSendId });
      const token = store.getters["user/accessToken"];
      downloadFile("/resumePDF/makeResumePDF", {
        id: row.postSendId,
        token: token,
      });
      this.$message.success({
        showClose: true,
        message: "下载中...,请在浏览器的下载中查看",
        duration: messageDuration,
      });
    },
    async handleDownWord(row) {
      // await downloadWord({ id: row.postSendId });
      const token = store.getters["user/accessToken"];
      downloadFile("/resumeWord/makeResumeWord", {
        id: row.postSendId,
        token: token,
      });
      this.$message.success({
        showClose: true,
        message: "下载中...,请在浏览器的下载中查看，word请用office打开",
        duration: messageDuration,
      });
    },
    async markNotFit() {
      let selects = this.$refs.pageTable.getSelection();
      let postSendIdsStr = "";
      if (selects && selects.length > 0) {
        if (this.isOpend) {
          this.$confirm(
            "确认标记为不合适吗？将会给投递人发送简历不通过的邮件"
          ).then(async () => {
            for (let i in selects) {
              postSendIdsStr += selects[i].postSendId + ",";
            }
            postSendIdsStr = postSendIdsStr.substr(
              0,
              postSendIdsStr.length - 1
            );
            let res = await unSuitResume({
              postSendId: postSendIdsStr,
              message: this.isOpend ? this.noFitMessage : "",
            });
            if (res.success) {
              this.popVisible = false;
              this.$message.success({
                showClose: true,
                message: "已标记为不合适!",
                duration: messageDuration,
              });
              await this.refreshPage();
              await this.initStatisticData();
            } else {
              this.$message.error({ showClose: true, message: res.message });
            }
          });
        } else {
          for (let i in selects) {
            postSendIdsStr += selects[i].postSendId + ",";
          }
          postSendIdsStr = postSendIdsStr.substr(0, postSendIdsStr.length - 1);
          let res = await unSuitResume({
            postSendId: postSendIdsStr,
            message: this.isOpend ? this.noFitMessage : "",
          });
          if (res.success) {
            this.popVisible = false;
            this.$message.success({
              showClose: true,
              message: "已标记为不合适!",
              duration: messageDuration,
            });
            await this.refreshPage();
            await this.initStatisticData();
          } else {
            this.$message.error({ showClose: true, message: res.message });
          }
        }
      } else {
        this.$message.warning({
          showClose: true,
          message: "请勾选需要标记的简历",
        });
      }
    },
    async markFavorite() {
      let selects = this.$refs.pageTable.getSelection();
      let postSendIdsStr = "";
      if (selects && selects.length > 0) {
        for (let i in selects) {
          postSendIdsStr += selects[i].postSendId + ",";
        }
        postSendIdsStr = postSendIdsStr.substr(0, postSendIdsStr.length - 1);
        let res = await collectResume({
          userCode: this.userCode,
          postSendId: postSendIdsStr,
        });
        if (res.success) {
          this.$message.success({
            showClose: true,
            message: "已收藏!",
            duration: messageDuration,
          });
          await this.refreshPage();
          await this.initStatisticData();
        } else {
          this.$message.error({ showClose: true, message: res.message });
        }
      } else {
        this.$message.warning({
          showClose: true,
          message: "请勾选需要标记的简历",
        });
      }
    },
    async unmarkFavorite() {
      let selects = this.$refs.pageTable.getSelection();
      let postSendIdsStr = "";
      if (selects && selects.length > 0) {
        for (let i in selects) {
          postSendIdsStr += selects[i].postSendId + ",";
        }
        postSendIdsStr = postSendIdsStr.substr(0, postSendIdsStr.length - 1);
        let res = await unCollectResume({
          userCode: this.userCode,
          postSendId: postSendIdsStr,
        });
        if (res.success) {
          this.$message.success({
            showClose: true,
            message: "已取消收藏!",
            duration: messageDuration,
          });
          await this.refreshPage();
          await this.initStatisticData();
        } else {
          this.$message.error({ showClose: true, message: res.message });
        }
      } else {
        this.$message.warning({
          showClose: true,
          message: "请勾选需要标记的简历",
        });
      }
    },
    async markReaded() {
      let selects = this.$refs.pageTable.getSelection();
      let postSendIdsStr = "";
      if (selects && selects.length > 0) {
        for (let i in selects) {
          postSendIdsStr += selects[i].postSendId + ",";
        }
        postSendIdsStr = postSendIdsStr.substr(0, postSendIdsStr.length - 1);
        let res = await markIsRead({ postSendId: postSendIdsStr });
        if (res.success) {
          this.$message.success({
            showClose: true,
            message: "已标记为已读!",
            duration: messageDuration,
          });
          await this.refreshPage();
        } else {
          this.$message.error({ showClose: true, message: res.message });
        }
      } else {
        this.$message.warning({
          showClose: true,
          message: "请勾选需要标记的简历",
        });
      }
    },
    async pdfPackage() {
      let selects = this.$refs.pageTable.getSelection();
      if (selects && selects.length > 0 && selects.length < 51) {
        let list = [];
        for (let i in selects) {
          list.push(selects[i].id);
        }
        const token = store.getters["user/accessToken"];
        downloadFile("/resumePDF/getResumePdfZip", { ids: list, token: token });
        this.$message.success({
          showClose: true,
          message:
            "打包" +
            selects.length +
            "条,服务器生成文件中，请耐心等待...，完成后在浏览器的下载栏中查看",
          duration: 4000,
        });
        // let res = await downloadPdfPackage({ ids: list, token: token });
        // console.log(res);
        this.$refs.pageTable.clearSelection();
      } else if (selects && selects.length > 51) {
        this.$message.warning({
          showClose: true,
          message: "一次最多只能选择50条",
        });
      } else {
        this.$message.warning({
          showClose: true,
          message: "请勾选需要打包下载的简历",
        });
      }
    },
    async wordPackage() {
      let selects = this.$refs.pageTable.getSelection();
      if (selects && selects.length > 0 && selects.length < 51) {
        let list = [];
        for (let i in selects) {
          list.push(selects[i].id);
        }
        const token = store.getters["user/accessToken"];
        downloadFile("/resumeWord/getResumeWordZip", {
          ids: list,
          token: token,
        });
        this.$message.success({
          showClose: true,
          message:
            "打包" +
            selects.length +
            "条,服务器生成文件中，请耐心等待...，完成后在浏览器的下载栏中查看，word请用office打开",
          duration: 4000,
        });
        // let res = await downloadWordPackage({ ids: list, token: token });
        // console.log(res);
        this.$refs.pageTable.clearSelection();
      } else if (selects && selects.length > 51) {
        this.$message.warning({
          showClose: true,
          message: "一次最多只能选择50条",
        });
      } else {
        this.$message.warning({
          showClose: true,
          message: "请勾选需要打包下载的简历",
        });
      }
    },
    viewResume(id, phase, university) {
      this.$router.push({
        path: "/personalResumeView/index",
        query: {
          postSendId: id,
          phase: phase,
          university: university,
          ...this.pageInfo,
          activeName: this.activeName,
          queryForm: this.queryForm,
        },
      });
    },
    scienceValFormat(value) {
      let jsonData = [];
      if (!value) {
        return value;
      }
      try {
        jsonData = JSON.parse(value);
      } catch (error) {
        if (value.indexOf(",") > 0) {
          jsonData = value.split(",");
        } else {
          jsonData = value;
        }
      }

      if (isArray(jsonData)) {
        const result = jsonData.map((data) => {
          const res = this.scienceArray.filter((val) => val.code == data);
          if (res && res.length > 0) {
            return res.map((value1) => value1.name).join(",");
          } else {
            return data;
          }
        });
        if (result && result.length > 0) {
          return result.join(",");
        }
      } else if (typeof jsonData == "string") {
        const result = this.scienceArray.filter((val) => val.code == jsonData);
        if (result && result.length > 0) {
          return result.map((value1) => value1.name).join(",");
        }
      }
      return jsonData;
    },
    eduRequireFormat(value) {
      const result = this.eduTypeArray.filter((val) => val.code == value);
      return result[0] ? result[0].name : value;
    },
    dateFormat(value) {
      if (value && typeof value == "string") {
        return value.substr(0, 10);
      } else {
        return value;
      }
    },
    sexFormat(value) {
      if (value == "female") {
        return "女";
      } else {
        return "男";
      }
    },
    // 配置页面-----------------
    // 邮箱配置
    async emailConfig() {
      this.emailDialogData = {
        action: "edit",
        data: { deptCode: this.deptCode },
      };
      // 获取邮箱配置
      let res = await getEmailData({ deptCode: this.deptCode });
      if (res.success) {
        if (res.data) {
          this.$set(
            this.emailDialogData.data,
            "email",
            res.data.email ? res.data.email : ""
          );
          this.$set(
            this.emailDialogData.data,
            "key",
            res.data.key ? res.data.key : ""
          );
          this.$set(
            this.emailDialogData.data,
            "address",
            res.data.address ? res.data.address : ""
          );
          this.$set(
            this.emailDialogData.data,
            "isOpen",
            res.data.isOpen && res.data.isOpen == "true" ? true : false
          );
          this.$set(
            this.emailDialogData.data,
            "id",
            res.data.id ? res.data.id : ""
          );
        } else {
          this.$set(this.emailDialogData.data, "email", "");
          this.$set(this.emailDialogData.data, "key", "");
          this.$set(this.emailDialogData.data, "address", "");
          this.$set(this.emailDialogData.data, "isOpen", false);
        }
      } else {
        this.$message.warning({
          showClose: true,
          message: res.message,
        });
        return;
      }
      this.emailDialogVisible = true;
    },
    async emailInitDialogData(data) {
      return data.data;
    },
    async emailSaveDialogData(data) {
      let emailData = {
        email: data.email,
        key: data.key,
        isOpen: data.isOpen ? "true" : "false",
        address: data.address,
        id: data.id ? data.id : null,
        deptCode: this.deptCode,
      };
      let res = await saveEmailData({ email: JSON.stringify(emailData) });
      if (res.success) {
        this.$message({
          showClose: true,
          message: "保存成功",
          type: "success",
        });
        this.$emit("callBack", { data: res });
      } else {
        this.$message({
          showClose: true,
          message: "保存失败!" + res.message,
          type: "error",
        });
      }
    },
    emailDialogVisibleChange(val) {
      this.emailDialogVisible = val;
    },
    emailDialogCallBack(callBackResult) {
      // 保存后刷新页面
      this.inintEmail();
    },
    openURL(num) {
      if (num == 1) {
        window.open(
          "https://jingyan.baidu.com/article/adc815139f60c2f723bf7385.html"
        );
      } else if (num == 2) {
        window.open(
          "https://service.mail.qq.com/cgi-bin/help?subtype=1&id=28&no=1001256"
        );
      }
    },
    readEmail(email, form) {
      let index = email.lastIndexOf("@");
      if (index > 0) {
        let string = email.substring(index + 1, email.length);
        form.address = "smtp." + string;
      }
    },
    // 权重配置
    async configPage() {
      // 取学校列表
      let res = await searchBasicData({ typeCode: "university" });
      if (res.success) {
        this.universityList = res.data;
      } else {
        this.$message.warning({
          showClose: true,
          message: res.message,
        });
        return;
      }
      // 设置编辑页面初始化的值
      this.dialogData = {
        action: "edit",
        data: { deptCode: this.deptCode },
      };

      // 获取配置的权重的值
      let res1 = await getConfigData({ deptCode: this.deptCode });
      if (res1.success) {
        let configData = res1.data;
        this.$set(
          this.dialogData.data,
          "cet4",
          configData.engLevel.cet4 ? configData.engLevel.cet4 : 0
        );
        this.$set(
          this.dialogData.data,
          "cet6",
          configData.engLevel.cet6 ? configData.engLevel.cet6 : 0
        );
        this.$set(
          this.dialogData.data,
          "tem4",
          configData.engLevel.tem4 ? configData.engLevel.tem4 : 0
        );
        this.$set(
          this.dialogData.data,
          "tem8",
          configData.engLevel.tem8 ? configData.engLevel.tem8 : 0
        );
        this.$set(
          this.dialogData.data,
          "博士",
          configData.degree["博士"] ? configData.degree["博士"] : 0
        );
        this.$set(
          this.dialogData.data,
          "硕士",
          configData.degree["硕士"] ? configData.degree["硕士"] : 0
        );
        this.$set(
          this.dialogData.data,
          "学士",
          configData.degree["学士"] ? configData.degree["学士"] : 0
        );
        for (let i in configData.universities) {
          this.$set(this.dialogData.data, [i], configData.universities[i]);
        }
        this.dialogVisible = true;
      } else {
        this.$message.warning({
          showClose: true,
          message: res1.message,
        });
        this.dialogVisible = true;
      }
    },
    async excelRecordLoad() {
      const res = await getsImportExcelRecord({
        deptCode: this.deptCode,
      });
      if (res.data && res.data.data) {
        this.$refs.excelRecord.open(res.data.data);
      } else {
        this.$refs.excelRecord.open();
      }
    },
    async wordPackageAfterExcel() {
      this.$confirm(
        "确认要进行简历数据打包下载吗？(建议进行条件筛查后再进行此打包操作，一次打包数据过多，渲染数据会导致速度很慢！此操作一般在进行相同条件查询的excel导出操作后进行！)"
      )
        .then(async () => {
          const token = store.getters["user/accessToken"];
          await downloadFile("/resume/wordPackageAfterExcel", {
            dept: this.deptCode,
            token: token,
            name: encodeURI(this.queryForm.name),
            phase: encodeURI(this.queryForm.phase),
            postName: encodeURI(this.queryForm.postName),
            university: encodeURI(this.queryForm.university),
            studyField: encodeURI(this.queryForm.studyField),
            politicallyState: encodeURI(this.queryForm.politicallyState),
            sendDateStart: encodeURI(this.queryForm.sendDateStart),
            sendDateEnd: encodeURI(this.queryForm.sendDateEnd),
            isSuitable: encodeURI(this.isSuitable),
          });
          this.$message.success({
            showClose: true,
            message:
              "服务器生成文件中，请耐心等待...，完成后在浏览器的下载栏中查看",
            duration: 4000,
          });
        })
        .catch((e) => {
          this.$message.info({ showClose: true, message: "已取消打包下载" });
        });

      // let res = await downloadWordPackage({ ids: list, token: token });
      // console.log(res);
    },
    // excel导出
    async excelExport() {
      this.$confirm(
        "确认要进行excel数据导出吗？(建议进行条件筛查后再进行此导出操作，一次导出数据过多，渲染数据会导致速度很慢！)"
      )
        .then(async () => {
          const token = store.getters["user/accessToken"];
          await downloadFile("/resume/downloadExcel", {
            dept: this.deptCode,
            token: token,
            name: encodeURI(this.queryForm.name),
            phase: encodeURI(this.queryForm.phase),
            postName: encodeURI(this.queryForm.postName),
            university: encodeURI(this.queryForm.university),
            studyField: encodeURI(this.queryForm.studyField),
            politicallyState: encodeURI(this.queryForm.politicallyState),
            sendDateStart: encodeURI(this.queryForm.sendDateStart),
            sendDateEnd: encodeURI(this.queryForm.sendDateEnd),
            isSuitable: encodeURI(this.isSuitable),
          });
          setTimeout(() => {
            this.loading = false;
          }, 5000);
          await this.refreshPage();
        })
        .catch((e) => {
          this.$message.info({ showClose: true, message: "已取消导出" });
        });
    },
    //职位数据导出
    // async resumeExcelExport() {
    //   this.$confirm(
    //       "确认要进行简历数据导出导出吗？(建议进行条件筛查后再进行此导出操作，一次导出数据过多，渲染数据会导致速度很慢！)"
    //   )
    //       .then(async () => {
    //         const token = store.getters["user/accessToken"];
    //         this.loading=true;
    //         await downloadFile("/resume/resumeExcelExport", {
    //           dept: this.deptCode,
    //           token: token,
    //           name: encodeURI(this.queryForm.name),
    //           phase: encodeURI(this.queryForm.phase),
    //           postName: encodeURI(this.queryForm.postName),
    //           university: encodeURI(this.queryForm.university),
    //           studyField: encodeURI(this.queryForm.studyField),
    //           politicallyState: encodeURI(this.queryForm.politicallyState),
    //           sendDateStart: encodeURI(this.queryForm.sendDateStart),
    //           sendDateEnd: encodeURI(this.queryForm.sendDateEnd),
    //         });
    //         this.queryData();
    //         this.loading=false;
    //       })
    //       .catch((e) => {
    //         this.$message.info({ showClose: true, message: "已取消导出" });
    //       });
    // },
    // 结束招聘季
    async endRecruitQuarter() {
      this.$confirm(
        "本次招聘季所有的投递将变为结束状态，是否确认结束本次的招聘季吗？"
      )
        .then(async () => {
          const token = store.getters["user/accessToken"];
          const result = await endRecruitQuarter({ token: token });
          if (result.success) {
            this.$message({
              showClose: true,
              message: "执行成功！",
              type: "success",
            });
            this.queryData();
          } else {
            this.$message({
              showClose: true,
              message: result.message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          console.log(e);
          this.$message.info({ showClose: true, message: "已取消" });
        });
    },
    async excelImport() {
      this.$confirm("确认要进行投递结果的excel数据导入吗？")
        .then(async () => {
          const token = store.getters["user/accessToken"];
          this.$refs.uploadFileModel.open();
        })
        .catch((e) => {
          console.log(e);
          this.$message.info({ showClose: true, message: "已取消导入" });
        });
    },
    setSendResult(){
      let selects = this.$refs.pageTable.getSelection();
      if (selects && selects.length > 0 && selects.length < 51) {
        this.$refs.resultDialog.open();
      } else if (selects && selects.length > 51) {
        this.$message.warning({
          showClose: true,
          message: "一次最多只能选择50条",
        });
      } else {
        this.$message.warning({
          showClose: true,
          message: "请勾选需要手动设置投递结果的简历",
        });
      }
    },

    // 接收审核结果
    handleAuditConfirm(action) {
      let selects = this.$refs.pageTable.getSelection();
      let list = [];
      for (let i in selects) {
        list.push(selects[i].id);
      }
      setResultByHand({ids: list.join(','),action:action});
    },
    async initDialogData(data) {
      return data.data;
    },
    async saveDialogData(data) {
      let engLevel = {
        cet4: data.cet4 ? data.cet4 : null,
        cet6: data.cet6 ? data.cet6 : null,
        tem4: data.tem4 ? data.tem4 : null,
        tem8: data.tem8 ? data.tem8 : null,
      };
      let degree = {
        博士: data.博士 ? data.博士 : null,
        硕士: data.硕士 ? data.硕士 : null,
        学士: data.学士 ? data.学士 : null,
      };
      let deptCode = data.deptCode ? data.deptCode : null;
      if (data.cet4) delete data.cet4;
      if (data.cet6) delete data.cet6;
      if (data.tem4) delete data.tem4;
      if (data.tem8) delete data.tem8;
      if (data.博士) delete data.博士;
      if (data.硕士) delete data.硕士;
      if (data.学士) delete data.学士;
      if (data.deptCode) delete data.deptCode;
      let transData = {
        engLevel: engLevel,
        degree: degree,
        universities: data,
        deptCode: deptCode,
      };
      saveConfigData({ record: JSON.stringify(transData) }).then((res) => {
        if (res.success) {
          this.$message({
            showClose: true,
            message: "保存成功",
            type: "success",
          });
          this.close();
          this.$emit("callBack", { data: res });
        } else {
          this.$message({
            showClose: true,
            message: "保存失败!" + res.message,
            type: "error",
          });
        }
      });
    },
    dialogVisibleChange(val) {
      this.dialogVisible = val;
    },
    dialogCallBack(callBackResult) {},
  },
};
</script>

<style scoped lang="scss">
@import "public/static/scss/commTableLayouts";
.item {
  margin-top: 10px;
  margin-right: 40px;
}
.page-box {
  margin-top: 5px;
  height: calc(#{$base-app-main-height} - 10px);
}
.tagActive {
  background-color: #44aaee;
  color: whitesmoke;
}
.tagsBox {
  margin-top: 20px;
  margin-left: 10px;
  span {
    cursor: pointer;
  }
}
.waiting {
  color: $base-font-color;
}
.pass {
  color: $base-color-green;
}
.notPass {
  color: $base-color-red;
}
.primarySelect {
  color: $base-color-blue;
}

.postInfo {
  mini-height: 80px;
  table-layout: fixed;
  position: relative;
  overflow: hidden;
  flex: 1;
  width: 100%;
  max-width: 100%;
  font-size: 12px;
  color: #606266;

  .p-first,
  .p-second,
  .p-third {
    margin-top: 5px;
  }

  .science,
  .sex,
  .phase,
  .university,
  .eduRequire,
  .studyField,
  .age,
  .requireNum {
    margin-left: 5px;
  }
  .isRead {
    float: right;
  }
  .name {
    font-weight: bold;
  }

  .postCount,
  .viewCount {
    position: relative;
    height: 100%;
    text-align: center;
    font-size: 30px;
    //font-weight: bold;
    color: #44aaee;

    span {
      font-size: 12px;
      color: #44aaee;
    }
  }
}

//.postInfo:nth-child(odd) {
//  background-color: #fafafa;
//}
//
//.postInfo:nth-child(even) {
//  background-color: #ffffff;
//}

.postInfo1 {
  background-color: #f3f3f3;
  //background-color: #0196a7;
}

.postInfo2 {
  background-color: #ffffff;
}

@mixin row-line {
  content: " ";
  height: 1px;
  width: 100%;
  background-color: #ebeef5;
}

.postInfo:before {
  @include row-line;
}

.rowLine {
  @include row-line;
}

.p-first,
.p-second,
.p-third {
  margin-top: 5px;
}

>>> label.el-form-item__label {
  width: 300px;
}

::v-deep .el-card__body {
  padding: 10px 5px 5px 5px;
}
::v-deep .el-card__header {
  padding: 5px 20px;
}
::v-deep .gray-row {
  background: #f3f3f3;
  //cursor: not-allowed !important;
}
</style>
